import { IconMapPin, IconChartDots, IconShieldCheck } from '@tabler/icons-react';

const features = [
  {
    icon: <IconMapPin stroke={2} size={24} />,
    label: 'Nationwide Market Access',
  },
  {
    icon: <IconChartDots stroke={2} size={24} />,
    label: 'Real-Time Analytics & Insights',
  },
  {
    icon: <IconShieldCheck stroke={2} size={24} />,
    label: 'Enterprise-Grade Security',
  },
];

const LoginMarketingMessage = () => {
  return (
    <div className="w-full max-w-[800px] text-white">
      <h1 className="font-heebo text-xl font-bold leading-tight md:text-[64px]">
        Transforming <span className="text-violet-600">Secondary</span>{' '}
        <span className="text-violet-600">Loan </span>Markets
      </h1>
      <p className="mt-4 font-heebo font-normal leading-relaxed md:mt-8">
        The institutional electronic trading platform connecting banks, credit unions, and funds
        across the U.S. for efficient, real-time whole loan and participation trades.
      </p>

      <div className="mt-4 hidden flex-col gap-4 md:mt-10 md:flex md:flex-row md:justify-between">
        {features.map(({ icon, label }) => (
          <div key={label} className="flex items-center gap-2">
            <div className="flex h-[44px] w-[44px] items-center justify-center rounded-full bg-pink-900 p-[10px] text-pink-400">
              {icon}
            </div>
            <p className="font-heebo text-[14px]">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoginMarketingMessage;
